import {
    Button, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'appkit-react';

const appTitle = process.env.REACT_APP_TITLE;
const termUseMsg = `${appTitle} Terms Of Use Coming Soon...`;

const TermsOfUse = ({ setTermsModal }) => (
    <>
        <Modal
            className="baseline-modal-showcase"
            visible
            onCancel={() => setTermsModal(false)}
        >
            <ModalHeader>
                <div className="modal-title">Terms of use</div>
            </ModalHeader>
            <ModalBody style={{ height: '70vh' }}>
                {/* <p>{termUseMsg}</p> */}
                <iframe
                    src="/TermsOfUse.html"
                    title="Terms of Use"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                />
            </ModalBody>
            <ModalFooter style={{ justifyContent: 'flex-end' }}>
                <Button kind="transparent" onClick={() => setTermsModal(false)}> OK </Button>
            </ModalFooter>
        </Modal>
    </>
);

export default TermsOfUse;
